import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setClientDashboardTiles,
  setUserData,
} from "../../../store/features/generalSlice";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import TileAccordion from "./TileAccordion";
import { Link, useNavigate } from "react-router-dom";
import { createUserFav, exportResource } from "../../../services/user";
import ResourceInfoModal from "./ResourceInfoModal";
import Moment from 'react-moment';
import 'moment-timezone';
import AlertMessage from "../../../components/admin/AlertMessage";
import AddMyFavourites from "./AddMyFavourites";

import Eye from "../../../assets/theme/images/eye.png";
import Export from "../../../assets/theme/images/export.png";

import {
  Info,
  Pin,
  Edit,
  TrashTwo,
  ExportIcn,
  ReportOne,
  LoaderAcc,
  Reports,
  DashboardTwo,
} from "../../../assets/theme/images/icons";
import { GetDashboardTiles } from "../../../services";

function CustomToggle({
  children,
  eventKey,
  workspaceId,
  clientId,
  resourceId,
}) {
  const [data, setData] = useState([]);
  const [accessToken, setAccessToken] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [error, setError] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const userData = useSelector((state) => state.general.userData);
  const general = useSelector((state) => state.general);
  const dispatch = useDispatch();
  // const decoratedOnClick = useAccordionButton(eventKey, () =>
  //   GetDashboardTilesList(resourceId)
  // ); //Commented out as per latest client requirement to avoid tile display
  async function GetDashboardTilesList(resourceId) {
    let user = false;
    user = {
      token: userData.accessToken,
    };
    let ignore = false;
    const response = await GetDashboardTiles(resourceId, user).catch(
      (error) => {
        if (error.code && error.code == "ERR_NETWORK") {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          setError(error.response.data.message);
          ignore = true;
          setShowLoader(false);
        } else if (error.request) {
          ignore = true;
          // The request was made but no response was received
          setError("No response received from the server.");
          setShowLoader(false);
        } else {
          ignore = true;
          // Something happened in setting up the request that triggered an error
          setError("An error occurred while processing the request.");
          setShowLoader(false);
        }
      }
    );

    if (!ignore) {
      dispatch(
        setClientDashboardTiles({ clientDashboardTiles: response.data })
      );
      setShowLoader(false);
    }
  }

  return (
    <button  type="button"
      //onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

function AllDashboardTile({ workspaceId = null, clientId = null }) {
  const [name, setName] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const userData = useSelector((state) => state.general.userData);
  //console.log("ReportAccordion", workspaceId, clientId);
  const general = useSelector((state) => state.general);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(false);
  const [error, setError] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let clientDashboard = [];
  // Update the options state
  clientDashboard = general?.typewiseResources &&
  general?.typewiseResources["Dashboard"]
    ? general.typewiseResources["Dashboard"]
    : [];
    
  function showDescriptionModal(item) {
    console.log("showDescriptionModal");
    setShowModal(true);
    setModalData(item);
  }
  const handleClick = (myLink) => () => {
    window.location.href=myLink;
  }
  const handleClose = () => setShowModal(false);
  async function getUserData() {
    let pbUser = false;

    if (!userData) {
      pbUser = await localStorage.getItem("pbUser");

      if (pbUser) {
        pbUser = JSON.parse(pbUser);
        setAccessToken(pbUser.accessToken);
        dispatch(setUserData({ userData: pbUser }));
      }
    }
    return pbUser;
  }
  
  async function exportDashboard(resourceId) {
    let user = false;
    setShowLoader(true);
    if (!userData) {
      let pbUser = getUserData();
      user = {
        token: pbUser.accessToken,
      };
    } else {
      user = {
        token: userData.accessToken,
      };
    }
    let params = {
      fileFormat: 1,
      resourceType: "Dashboard",
    };
    exportResource(resourceId, params, user)
      .then((res) => {
        let succesMessage = "Export request completed successfully.";
        localStorage.setItem("alertMessage", succesMessage);
        setAlertMessage(succesMessage);
        //navigate("/client-list");
      })
      .catch((error) => {
        console.log("error", error);
        setShowLoader(false);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          setError(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setError("No response received from the server.");
        } else {
          // Something happened in setting up the request that triggered an error
          setError("An error occurred while processing the request.");
        }
      });
  }
  return (
    <div>
      {alertMessage && (
        <AlertMessage alertMessage={alertMessage} alertType={"success"} />
      )}
      {error && <AlertMessage alertMessage={error} alertType={"error"} />}
      {general?.succesMessage && (
        <AlertMessage alertMessage={general?.succesMessage} alertType={"success"} />
      )}
      {general?.errorMessage && <AlertMessage alertMessage={general?.errorMessage} alertType={"error"} />}
      <div className="tile-card grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {clientDashboard &&
        clientDashboard.length > 0 &&
        clientDashboard.map((item) => (
            <a href={`/user/embeded-view/${item.id}`} key={item.id} className="bg-white p-4 rounded-2xl shadow-lg flex flex-col items-center text-center cursor-pointer hover:shadow-xl">

            <div className="text-6xl p-4">
            <span title={item?.lastRefresh?.startTime ? item?.lastRefresh?.startTime : '' }>
            <DashboardTwo/>
            </span>
            <h2 class="text-sm font-bold"><span className="tile-card-text-overflow" title={item.aliasName ? item.aliasName : item.name}>{item.aliasName ? item.aliasName : item.name}</span></h2>
            </div>
                   <div className="tile-flex-grow"></div>
                           <div className="flex tile-card-center">            
                            <div className="accordion-actions tile-icon-gap">
                                <div className="buttons">
                                <a href={`/user/embeded-view/${item.id}`}>
                                    <img src={Eye} alt="" /> View
                                </a>
                                </div>
                                <div className="icons">
                                <Link onClick={() => showDescriptionModal(item)}>
                                    <Info />
                                </Link>
                                <AddMyFavourites itemId={item.id}  resourceType={"Dashboard"}/>
                                </div>
                            </div>
                </div>
             
            </a>))}
            </div>
      {clientDashboard && clientDashboard.length <= 0 && !showLoader && (
        <div/>
      )}
      <ResourceInfoModal
        show={showModal}
        handleClose={handleClose}
        modalData={modalData}
      />
    </div>
  );
}

export default AllDashboardTile;
